import type { Option } from "@tento-lona/sheets";

/**
 * Column-scene retention at most once per frame (F14). The sheet element
 * asked its binder to retain the scenes of every rendered column inside each
 * column's bind, resolving every rendered column each time: O(columns²) per
 * full emit. The rendered set cannot change inside one drain, so retention
 * runs once per (frame, column mapper, rendered count) and the other binds in
 * that drain skip it.
 */
export class ColumnRetentionGate {
  #last: Option<{ readonly frame: number; readonly mapper: object; readonly rendered: number }> = null;

  /** Run `retain` unless it already ran for this frame, mapper and rendered count; returns whether it ran. */
  retainOnce(frame: number, mapper: object, rendered: number, retain: () => void): boolean {
    const last = this.#last;
    if (last != null && last.frame === frame && last.mapper === mapper && last.rendered === rendered) return false;
    retain();
    this.#last = { frame, mapper, rendered };
    return true;
  }

  /** Forget the last retention (a navigation or detach). */
  reset(): void {
    this.#last = null;
  }
}
